/**
 * Subpage Section Definitions — Defines available sections per content page.
 * Each section has a key, label, icon, and whether it's always-on (e.g., Hero).
 * Used by SubpageSectionToggles and the HTML/Preview generators.
 */

export interface SubpageSection {
  key: string;
  label: string;
  icon: string;
  alwaysOn?: boolean;
}

export const angebotSections: SubpageSection[] = [
  { key: 'hero', label: 'Hero', icon: '\u{1F3AF}', alwaysOn: true },
  { key: 'packages', label: 'Pakete / Preise', icon: '\u{1F4E6}' },
  { key: 'cta', label: 'Call to Action', icon: '\u{1F4E2}' },
];

export const methodenSections: SubpageSection[] = [
  { key: 'hero', label: 'Hero', icon: '\u{1F3AF}', alwaysOn: true },
  { key: 'intro', label: 'Einleitung', icon: '\u{1F4DD}' },
  { key: 'steps', label: 'Methoden-Schritte', icon: '\u{1F9E9}' },
  { key: 'tools', label: 'Tools', icon: '\u{1F6E0}\uFE0F' },
  { key: 'philosophy', label: 'Philosophie / CTA', icon: '\u{1F4A1}' },
];

export const ueberMichSections: SubpageSection[] = [
  { key: 'hero', label: 'Hero', icon: '\u{1F3AF}', alwaysOn: true },
  { key: 'timeline', label: 'Werdegang', icon: '\u{1F4C5}' },
  { key: 'values', label: 'Werte', icon: '\u2B50' },
  { key: 'certifications', label: 'Zertifizierungen', icon: '\u{1F3C5}' },
];

export const subpageSectionMap: Record<string, SubpageSection[]> = {
  angebot: angebotSections,
  methoden: methodenSections,
  ueberMich: ueberMichSections,
};

/** Creates a default sections toggle object (all enabled) for a given page. */
export function createDefaultSections(pageKey: string): Record<string, boolean> {
  const defs = subpageSectionMap[pageKey];
  if (!defs) return {};
  const result: Record<string, boolean> = {};
  for (const s of defs) {
    result[s.key] = true;
  }
  return result;
}
